import { render, staticRenderFns } from "./Tenderdetails.vue?vue&type=template&id=a1d503d8&"
import script from "./Tenderdetails.vue?vue&type=script&lang=js&"
export * from "./Tenderdetails.vue?vue&type=script&lang=js&"
import style0 from "./Tenderdetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports